import { AdminHeaderButtonView } from '@vivli/shared/views';
import { useDataRequestContext } from '@vivli/features/data-requests/infrastructure/context';
import { downloadFile } from '@vivli/shared/infrastructure/hook';
import { finalize, first } from 'rxjs/operators';
import { useDataRequestsApiContext, useModalApiContext } from '@vivli/core/infrastructure/context';
import { useState } from 'react';

export const PrintButtonView = () => {
    const { dataRequest, includeRiskScore } = useDataRequestContext();
    const api = useDataRequestsApiContext();
    const modalService = useModalApiContext();
    const [isLoading, setIsLoading] = useState(false);

    const handleError = (error) => {
        modalService.error(error);
    };
    const handlePrintClick = () => {
        setIsLoading(true);
        const dataRequestId = dataRequest.dataRequestDoi ? dataRequest.dataRequestDoi : dataRequest.id;
        api.downloadDataRequestPdf(dataRequest.id, includeRiskScore)
            .pipe(
                first(),
                finalize(() => setIsLoading(false))
            )
            .subscribe((data) => {
                downloadFile(
                    'data:application/pdf;base64,' + data,
                    `DataRequest-${dataRequestId}-${new Date().toDateString().replace(/ /g, '_')}.pdf`
                );
            }, handleError);
    };

    return <AdminHeaderButtonView title={'Download PDF'} style={{ marginLeft: 10 }} onClick={handlePrintClick} isLoading={isLoading} />;
};
